import { encodeReplay, replayDescription } from './Replay.mjs';

// Check again after compression: a canceled or superseded request must not download.
export async function downloadReplay(data, isCurrent = () => true) {
    const { blob, extension } = await encodeReplay(data);
    if (!isCurrent()) return null;
    const url = URL.createObjectURL(blob), link = document.createElement('a');
    link.href = url;
    link.download = replayDescription(data).replace(/[^a-z0-9]+/gi, '-').slice(0, 120) + extension;
    document.body.append(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    return blob.size;
}
